import React, { Component } from "react";
import { Button } from "react-bootstrap-buttons";
import { Form, Formik, Field } from "formik";

class VideoDownloadModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			resolution: "720p",
			length: "normal",
			orientation: "portrait",
		};
	}

	cancelModal = () => {
		this.props.cancelModal();
	};

	handleDownload = (values, actions) => {
		const { resolution, length, orientation } = this.state;
		const shortVersion = length === "short";
		this.props.downloadVideo(resolution, shortVersion, orientation);
		actions.setSubmitting(false);
		this.props.cancelModal();
	};

	changeHandler = (field, value) => {
		this.setState((prevState) => ({
			...prevState,
			[field]: value,
		}));
	};

	render() {
		return (
			<div>
				<div className="modal-backdrop bg-secondary opacity6" />
				<div className="modal d-inline-block">
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content pl-5 pr-5 pt-3 pb-3 m-auto bg--gray1">
							<Formik
								enableReinitialize={true}
								onSubmit={this.handleDownload}
								initialValues={{}}
							>
								{({ isSubmitting }) => (
									<Form>
										<div className="modal-body px-0 ml-0 bg--gray1">
											<div className="m-auto bg--gray1 w-100">
												<div className="d-flex justify-content-between mb-3">
													<div>
														<div className="h5 mb-3">Resolution:</div>
														<div className="d-flex flex-column">
															<label className="d-flex align-items-center mb-2">
																<input
																	type="radio"
																	name="resolution"
																	value="720p"
																	checked={this.state.resolution === "720p"}
																	onChange={() => this.changeHandler("resolution", "720p")}
																	className="mr-2"
																/>
																720p video
															</label>
															<label className="d-flex align-items-center">
																<input
																	type="radio"
																	name="resolution"
																	value="1080p"
																	checked={this.state.resolution === "1080p"}
																	onChange={() => this.changeHandler("resolution", "1080p")}
																	className="mr-2"
																/>
																1080p video
															</label>
														</div>
													</div>

													<div>
														<div className="h5 mb-3">Length:</div>
														<div className="d-flex flex-column">
															<label className="d-flex align-items-center mb-2">
																<input
																	type="radio"
																	name="length"
																	value="normal"
																	checked={this.state.length === "normal"}
																	onChange={() => this.changeHandler("length", "normal")}
																	className="mr-2"
																/>
																Normal
															</label>
															<label className="d-flex align-items-center">
																<input
																	type="radio"
																	name="length"
																	value="short"
																	checked={this.state.length === "short"}
																	onChange={() => this.changeHandler("length", "short")}
																	className="mr-2"
																/>
																Short video
															</label>
														</div>
													</div>

													<div>
														<div className="h5 mb-3">Orientation:</div>
														<div className="d-flex flex-column">
															<label className="d-flex align-items-center mb-2">
																<input
																	type="radio"
																	name="orientation"
																	value="portrait"
																	checked={this.state.orientation === "portrait"}
																	onChange={() => this.changeHandler("orientation", "portrait")}
																	className="mr-2"
																/>
																Portrait
															</label>
															<label className="d-flex align-items-center">
																<input
																	type="radio"
																	name="orientation"
																	value="landscape"
																	checked={this.state.orientation === "landscape"}
																	onChange={() => this.changeHandler("orientation", "landscape")}
																	className="mr-2"
																/>
																Landscape
															</label>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="modal-footer p-0 border-0">
											<Button
												type="button"
												className="button-warning--modal p-1 mr-2"
												onClick={this.cancelModal}
											>
												Cancel
											</Button>
											<Button
												type="submit"
												className="button-success--modal p-1"
												disabled={isSubmitting}
											>
												Download Video
											</Button>
										</div>
									</Form>
								)}
							</Formik>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default VideoDownloadModal;